import { Loader2Icon } from "lucide-react"

import { cn } from "@/custolink-newdesign/lib/utils"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("cl:size-4 cl:animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
